module.exports = __webpack_public_path__ + "static/img/6.aecf61d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting711/images/6.png
// module id = Ojx0
// module chunks = 4